import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { CloseIcon } from '@winelidays/wld-tsx-2/images';
const FilterButton = (t0) => {
    const $ = _c(27);
    let children;
    let count;
    let hideResetAndCount;
    let isActive;
    let isFixed;
    let onReset;
    let props;
    if ($[0] !== t0) {
        ({ children, isActive, onReset, count, isFixed, hideResetAndCount, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = count;
        $[3] = hideResetAndCount;
        $[4] = isActive;
        $[5] = isFixed;
        $[6] = onReset;
        $[7] = props;
    }
    else {
        children = $[1];
        count = $[2];
        hideResetAndCount = $[3];
        isActive = $[4];
        isFixed = $[5];
        onReset = $[6];
        props = $[7];
    }
    const translate = useTranslate();
    let t1;
    if ($[8] !== onReset) {
        t1 = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onReset();
        };
        $[8] = onReset;
        $[9] = t1;
    }
    else {
        t1 = $[9];
    }
    const handleReset = t1;
    const computedClassName = `py-2 px-4 inline-flex flex-nowrap items-center ${isFixed ?
        "first:pl-4 first:rounded-l-full last:pr-4 last:rounded-r-full overflow-hidden !border-0 !text-primary !bg-white" :
        `my-1 justify-between max-w-full xxs:w-max xxs:max-w-79 xxs:mr-2 xxs:last:mr-0 sm:my-0 ${isActive ?
            "!bg-gray-400 !border-gray-400 !text-white" :
            "!text-gray-500 !border-gray-200 !bg-transparent hover:!bg-gray-400 hover:!border-gray-400 hover:!text-white"}`}`;
    const t2 = `messages.reset_filter${count ? "s" : ""}`;
    let t3;
    if ($[10] !== t2 || $[11] !== translate) {
        t3 = translate(t2);
        $[10] = t2;
        $[11] = translate;
        $[12] = t3;
    }
    else {
        t3 = $[12];
    }
    const resetTitle = t3;
    const resetClassName = `btn-ghost-outline ml-1 !px-1 !py-1 !inline mr-[-5px] inline-flex ${isFixed ? "!text-primary" : "!text-white"}`;
    let t4;
    if ($[13] !== children) {
        t4 = <span className="truncate flex-shrink-1 first-letter:uppercase pointer-events-none">
      {children}
    </span>;
        $[13] = children;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    let t5;
    if ($[15] !== count || $[16] !== handleReset || $[17] !== hideResetAndCount || $[18] !== isActive || $[19] !== resetClassName || $[20] !== resetTitle) {
        t5 = isActive && !hideResetAndCount ? <>

      {count ? <span className="ml-1">({count})</span> : null}
      <Button title={resetTitle} tag="span" onClick={handleReset} className={resetClassName}>
        <CloseIcon />
      </Button></> : null;
        $[15] = count;
        $[16] = handleReset;
        $[17] = hideResetAndCount;
        $[18] = isActive;
        $[19] = resetClassName;
        $[20] = resetTitle;
        $[21] = t5;
    }
    else {
        t5 = $[21];
    }
    let t6;
    if ($[22] !== computedClassName || $[23] !== props || $[24] !== t4 || $[25] !== t5) {
        t6 = <Button {...props} className={computedClassName}>{t4}{t5}
    </Button>;
        $[22] = computedClassName;
        $[23] = props;
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
    }
    else {
        t6 = $[26];
    }
    return t6;
};
export default FilterButton;
